export const TOKEN_STORAGE_USER_KEY = 'ls_managed_analytics_token'

export const LOGIN_STORAGE_USER = 'ls_managed_analytics_user'

export const  CODE_VERIFIER_STORAGE_KEY = 'ls_managed_analytics_code_verifier'
